import React, { useContext, useEffect, useState } from 'react'
import { Card, CardBody, Col, Modal, ModalBody, Row } from "reactstrap"
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg"
import ModifyPaymentListing from './ModifyPaymentListing'
import EditPaymentModeModal from './EditPaymentModeModal'
import { usePaymentCollectionReceiptContext } from '../../context'
import AButton from 'views/pages/manage/common/form-fields-mui/AButton'
import { initialForm } from 'views/pages/manage/unAssigned/collectPayment/selectPaymentMode/components/constant'
import ApprovalDialog from './ApprovalDialog'
import { getApproval, getRoleId } from '../utils'
import { UserDetails } from 'appContext'
import { fetchAllPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod'
import ALoader from 'views/pages/manage/common/a-loader'
import { endpoint } from '../../../../../../common/constant'
import { fetchAllPostPromisedData } from '../../../../../../common/utils/methods/commonMethods/utilityMethod'

const ModifyPayment = ({ isOpen, setIsOpen, rowList = [], totalPaidAmount = 0 }) => {
    const crossClickHandler = () => {
        setIsOpen(false)
        setModifyPaymentModeData({})
    }
    const [isEditModeModal, setIsEditModeModal] = useState(false)
    const [rowId, setRowId] = useState()
    const [isApprovalOpen, setApprovalOpen] = useState(false)
    const [oldPaymentMode, setOldPaymentMode] = useState()
    const [approverData, setApproverData] = useState()
    const data = useContext(UserDetails);

    const {
        noAmountChange,
        setNoAmountChange,
        setStudentBasicDetails,
        modifyPaymentModeData,
        setModifyPaymentModeData,
        setCurrentPaymentMode,
        setBankDropdown,
        setPaymentModeForm,
        roleId, setRoleId,
        setBankMasterId,
        balanceMode,
        setPaymentModeIdLimitList,
        bankDropdown, paymentModeIdLimitList,
        paymentModeFormHandler,
        collectVoucherList,
        state,
        setState,
        studentBasicDetails, currentPaymentMode, paymentModeForm, selectedChargesAmount, bankMasterId, setBalanceMode, setBalanceAmount, loader, setloader, setCollectPayment, balanceAmount, collectPayment,
        validatePaymentMode

    } = usePaymentCollectionReceiptContext();

    const getPaymentModeAndVouchersReqObj = () => {
        const { psid, applicationId, bu, businessArea, opportunityOwnerId } = studentBasicDetails;
        return {
            psid,
            applicationId: applicationId ?? null,
            roleId,
            businessArea: bu ?? businessArea,
            opportunityOwnerId,
            examRollNumber: null,
            processType: Boolean(applicationId) ? "Payment Collection" : "Exam Payment Collection",
        }
    }

    const getPaymentModesAndVouchers = async () => {
        const url = endpoint.paymentCollection.getVouchersAndPaymentMode;
        const req = getPaymentModeAndVouchersReqObj();
        return fetchAllPostPromisedData(url, req);
    }

    const contextValue = {
        noAmountChange,
        setNoAmountChange,
        setStudentBasicDetails,
        modifyPaymentModeData,
        setModifyPaymentModeData,
        setCurrentPaymentMode,
        setRoleId,
        setBankDropdown,
        setPaymentModeForm,
        roleId,
        setBankMasterId,
        balanceMode,
        setPaymentModeIdLimitList,
        bankDropdown, paymentModeIdLimitList,
        paymentModeFormHandler,
        collectVoucherList,
        state,
        setState,
        studentBasicDetails, currentPaymentMode, paymentModeForm, selectedChargesAmount, bankMasterId, setBalanceMode, setBalanceAmount, loader, setloader, setCollectPayment, balanceAmount, collectPayment,
        // getPaymentModeAndVouchersReqObj,
        getPaymentModesAndVouchers,
        validatePaymentMode
    }
    useEffect(() => {
        const fetchDetails = async (data) => {
            setloader(true)
            const roleId = await getRoleId(data)
            setRoleId(roleId)
            setloader(false)
        }
        data && fetchDetails(data);
    }, [data]);

    const handleApproval = async () => {
        try {
            setloader(true);
            const approverData = await getApproval(studentBasicDetails, (Object.values(modifyPaymentModeData))[0], bankMasterId, oldPaymentMode, setApprovalOpen, setIsOpen, setModifyPaymentModeData)
            setApproverData(approverData)
        }
        catch (err) {
            console.log(err)
        }
        finally {
            setloader(false);
        }
    }

    return <> <Modal
        isOpen={isOpen}
        style={{ maxWidth: '500px', width: '100%' }}
        size="xl"
        centered={true}
    >
        {loader && <ALoader position='fixed' />}
        <ModalBody className='p-4'>
            <div className='d-flex flex-column' style={{ gap: '24px' }}>
                <div className='d-flex flex-column' style={{ gap: '6px' }}>
                    <div className='d-flex justify-content-between'>
                        <div className='large-text label-color'>Modify payment method</div>
                        <CrossIcon onClick={crossClickHandler} />
                    </div>
                    <div className='regular-bold label-color'>
                        Update your payment method by choosing a new option and make sure all the new details you enter are accurate.
                    </div>
                </div>

                <ModifyPaymentListing oldPaymentMode={oldPaymentMode} setOldPaymentMode={setOldPaymentMode} setRowId={setRowId} rowList={rowList} totalPaidAmount={totalPaidAmount} contextValue={contextValue ? contextValue : {}} setIsEditModeModal={setIsEditModeModal} />
            </div>
            {/* <SelectPaymentMode contextValue={contextValue} isReceipt={isReceipt} isView={true}/> */}
            <Row><Col md={6}>
                <div className="mt-3" style={{ marginLeft: '-12px' }}>
                    <AButton
                        variant={"primary_filled"}
                        updatedStyle={{ width: '100%' }}
                        disabled={(Object.keys(modifyPaymentModeData).length == 0)}
                        onClick={() => { handleApproval() }}
                    >
                        Send for approval
                    </AButton>
                </div>
            </Col>
                <Col md={6}>
                    <div className="mt-3" style={{ marginLeft: '-12px' }}>
                        <AButton
                            variant="outline"
                            textColor="#262626"
                            outlineVariantColor='#CBCBCB'
                            updatedStyle={{ width: '100%' }}
                            disabled={''}
                            onClick={() => { setModifyPaymentModeData({}); setPaymentModeForm(initialForm); setBalanceMode(false) }}
                        >

                            Reset
                        </AButton>
                    </div>
                </Col>
            </Row>

        </ModalBody>
    </Modal>
        <ApprovalDialog isOpen={isApprovalOpen} setOpen={setApprovalOpen} approverData={approverData} />
        {isEditModeModal && <EditPaymentModeModal contextValue={contextValue} isOpen={isEditModeModal} setIsOpen={setIsEditModeModal} rowId={rowId} oldPaymentMode={oldPaymentMode} />}
    </>
}
export default ModifyPayment